import { Tooltip } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import type { WorkInProgressProjectStat } from "@src/__generated__/urql-graphql";
import { Icon } from "@src/components/ui-kit/Icon";
import { currency } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";
import React from "react";

interface BudgetProps {
  value: Pick<
    WorkInProgressProjectStat,
    "total_budget" | "total_budget_change"
  >;
}

const Budget = ({ value }: BudgetProps) => {
  return (
    <React.Fragment>
      <div>{currency.formatByWorkspace(value.total_budget)}</div>
      {value.total_budget_change !== 0 && (
        <Tooltip
          label={
            <div
              className="flex p-3 text-lg text-right"
              style={{ minWidth: 100, maxWidth: 300 }}
            >
              {t`Budget change since last month: `}

              {value.total_budget_change > 0 ? " +" : " -"}

              {currency.formatByWorkspace(value.total_budget_change)}
            </div>
          }
        >
          <div className="flex justify-end">
            <Icon name="alert-circle" color="red" />
          </div>
        </Tooltip>
      )}
    </React.Fragment>
  );
};

export default observer(Budget);
